// extracted by mini-css-extract-plugin
module.exports = {"root":"MergedInvoice_root__F_DIx","header":"MergedInvoice_header__GKrMd"};